"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_METRIC_ROWS = exports.resolveMetricColor = exports.getYtDepthColor = exports.getYtOriginalityColor = exports.getYtBiasColor = exports.getYtCredibilityColor = exports.NEUTRAL_METRIC_TINT = exports.NEUTRAL_METRIC_COLOR = exports.YT_DEPTH_COLORS = exports.YT_ORIGINALITY_COLORS = exports.YT_BIAS_COLORS = exports.YT_CREDIBILITY_COLORS = void 0;
const utils_1 = require("@repo/utils");
const palette_1 = require("./palette");
exports.YT_CREDIBILITY_COLORS = {
    ['0-40']: { default: 'rgb(220, 38, 38)', reason: '#F5DADD' },
    ['41-50']: { default: 'rgb(255, 165, 0)', reason: '#F8DDAC' },
    ['51-70']: { default: 'rgb(91, 180, 91)', reason: '#D0F3D0' },
    ['71-100']: { default: 'rgb(0, 128, 0)', reason: '#D0F3D0' },
};
exports.YT_BIAS_COLORS = {
    ['0-10']: { default: 'rgb(0, 128, 0)', reason: '#D0F3D0' },
    ['11-20']: { default: 'rgb(91, 180, 91)', reason: '#D0F3D0' },
    ['21-50']: { default: 'rgb(255, 165, 0)', reason: '#F8DDAC' },
    ['51-100']: { default: 'rgb(220, 38, 38)', reason: '#F5DADD' },
};
exports.YT_ORIGINALITY_COLORS = {
    ['0-40']: { default: '#dc2626', reason: '#F5DADD' },
    ['41-50']: { default: '#ffa500', reason: '#F8DDAC' },
    ['51-70']: { default: '#5bb45b', reason: '#D0F3D0' },
    ['71-100']: { default: '#008000', reason: '#D0F3D0' },
};
exports.YT_DEPTH_COLORS = {
    ['0-40']: { default: 'rgb(220, 38, 38)', reason: '#F5DADD' },
    ['41-50']: { default: 'rgb(255, 165, 0)', reason: '#F8DDAC' },
    ['51-70']: { default: 'rgb(91, 180, 91)', reason: '#D0F3D0' },
    ['71-100']: { default: 'rgb(0, 128, 0)', reason: '#D0F3D0' },
};
/** A score that is not known yet, as opposed to known and low. */
exports.NEUTRAL_METRIC_COLOR = palette_1.ANALYSIS_PALETTE.neutralMetric;
exports.NEUTRAL_METRIC_TINT = palette_1.ANALYSIS_PALETTE.neutralMetricTint;
/*
 * MISCOMPILATION GUARD: resolve a distinct range KEY per branch and index the
 * map once. The Next 16 / Turbopack minifier merges adjacent else-if branches
 * that each return `variant === 'default' ? X.default : X.reason`, silently
 * deleting a colour range. Do not "simplify" these back.
 */
const getYtCredibilityColor = (percentage, variant = 'default') => {
    const percent = Math.round(percentage ?? 0);
    let range;
    if (percent >= 71)
        range = '71-100';
    else if (percent >= 51)
        range = '51-70';
    else if (percent >= 41)
        range = '41-50';
    else
        range = '0-40';
    return exports.YT_CREDIBILITY_COLORS[range][variant];
};
exports.getYtCredibilityColor = getYtCredibilityColor;
const getYtBiasColor = (percentage, variant = 'default') => {
    const percent = Math.round(percentage ?? 0);
    let range;
    if (percent >= 51)
        range = '51-100';
    else if (percent >= 21)
        range = '21-50';
    else if (percent >= 11)
        range = '11-20';
    else
        range = '0-10';
    return exports.YT_BIAS_COLORS[range][variant];
};
exports.getYtBiasColor = getYtBiasColor;
const getYtOriginalityColor = (percentage, variant = 'default') => {
    const percent = Math.round(percentage ?? 0);
    let range;
    if (percent >= 71)
        range = '71-100';
    else if (percent >= 51)
        range = '51-70';
    else if (percent >= 41)
        range = '41-50';
    else
        range = '0-40';
    return exports.YT_ORIGINALITY_COLORS[range][variant];
};
exports.getYtOriginalityColor = getYtOriginalityColor;
const getYtDepthColor = (percentage, variant = 'default') => {
    const percent = Math.round(percentage ?? 0);
    let range;
    if (percent >= 71)
        range = '71-100';
    else if (percent >= 51)
        range = '51-70';
    else if (percent >= 41)
        range = '41-50';
    else
        range = '0-40';
    return exports.YT_DEPTH_COLORS[range][variant];
};
exports.getYtDepthColor = getYtDepthColor;
/**
 * The colour for a score-driven surface. An unknown score is neutral rather
 * than folded into the bottom bucket, which would assert a verdict (red for
 * confidence, green "no bias") the analysis never made.
 */
const resolveMetricColor = (getColor, score, variant = 'default') => {
    if ((0, utils_1.isValidScore)(score))
        return getColor(score, variant);
    return variant === 'default' ? exports.NEUTRAL_METRIC_COLOR : exports.NEUTRAL_METRIC_TINT;
};
exports.resolveMetricColor = resolveMetricColor;
/** The video metric grid, in the website's two rows of two. */
exports.VIDEO_METRIC_ROWS = [
    [
        {
            key: 'credibility',
            scoreKey: 'credibilityScore',
            titleKey: 'credibilityTitle',
            reasoningKey: 'credibilityReasoning',
            getColor: exports.getYtCredibilityColor,
        },
        {
            key: 'bias',
            scoreKey: 'biasScore',
            titleKey: 'biasLabel',
            reasoningKey: 'biasLabelReasoning',
            getColor: exports.getYtBiasColor,
        },
    ],
    [
        {
            key: 'originality',
            scoreKey: 'originalityScore',
            titleKey: 'originalityLabel',
            reasoningKey: 'originalityReasoning',
            getColor: exports.getYtOriginalityColor,
        },
        {
            key: 'depth',
            scoreKey: 'analyticalDepthScore',
            titleKey: 'analyticalDepthLabel',
            reasoningKey: 'analyticalDepthReasoning',
            getColor: exports.getYtDepthColor,
        },
    ],
];
